<template>
  <div>
    <div>
      <!-- Name Input -->
      <div class="col form-group mb-5">
        <input
          ref="nameInput"
          id="name"
          v-model="obj.firstName"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          class="w-100"
          :placeholder="!config.fullNameOneInput == true ? 'Nome' : 'Nome completo'"
          type="text"
        />
      </div>
      <!-- Surname Input -->
      <div v-if="!config.fullNameOneInput == true" class="col form-group">
        <input
          ref="nameInput"
          id="surname"
          v-model="obj.surname"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          class="w-100"
          placeholder="Sobrenome"
          type="text"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Name',
  props: {
    validate: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    obj: {},
    toastMessage: '',
  }),
  computed: {
    ...mapState(['template', 'config', 'subdomain', 'registrationObject']),
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Create a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    document.getElementById('name').focus()
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    makeToast(variant = null) {
      this.$bvToast.toast(this.toastMessage, {
        title: 'Atenção',
        variant: variant,
        solid: true,
      })
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.firstName) {
        hasErrors = true
        const warningMsg = 'É necessário informar seu nome.'
        this.addRegistrationError({ msg: warningMsg })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!this.obj.surname) {
        hasErrors = true
        const warningMsg = 'É necessário informar o seu sobrenome.'
        this.addRegistrationError({
          msg: warningMsg,
        })
        this.toastMessage = warningMsg
        this.makeToast('warning')
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
}
</script>
